import React, { Component } from 'react';

import Tab from "../../../../components/admin/etc/tab";

import CodeForm from "./module/code";
import JCRCategoriesForm from "./module/jcrCategories";
import ScopusCategoriesForm from "./module/scopusCategories";
import KCICategoriesForm from "./module/kciCategories";
import DeptForm from "./module/deptCategories";
import SubjectForm from "./module/subjectCategories";
import TempForm from "./module/tempCategories";

import { getParams, pushUrl } from '../../../../utils/functions'

const vObj = {
  0 : <CodeForm />,
  1 : <JCRCategoriesForm />,
  2 : <ScopusCategoriesForm />,
  3 : <KCICategoriesForm />,
  4 : <DeptForm />,
  5 : <SubjectForm />,
  // 6 : <TempForm />,
}

const arr = ["기본 코드", "JCR 카테고리", "Scopus 카테고리", "KCI 카테고리", "학과", "주제"];

class Categories extends Component {
  constructor(props) {
    super(props);

    const activeTabID = getParams('tab_id') ? getParams('tab_id') : 0;

    this.state = {
      activeTab: activeTabID === null ? 0 : activeTabID
    };
  }

  updateValue = (id) => {
    this.setState({
      activeTab: id
    });

    pushUrl('탭', 'admin.php?page=researchmind-type&tab_id='+id, null);
  }

  render() {
    const { updateValue } = this;

    return (
      <>
        <div className="container-fluid mt-3 detail-wrap">
          <div className="row">
            <div className="col pl-0 detail code-detail">
              <div className="detail-tabs">
                <Tab
                    tabList={arr}
                    changeTab={updateValue}
                    activeID={this.state.activeTab}
                />
              </div>
              <div className="detail-content">
                {
                  vObj[this.state.activeTab]
                }
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default Categories